// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__A5JOO","errorLogs":"styles_errorLogs__o9G9E"};